import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing the FilterBetsReportView.
 * @extends JetView
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Getting the screen size configuration

        // Left section of the form with date picker
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange', // Custom CSS class
                    readonly: true, // Make the input read-only
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Center left section with Ticket Id input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for Ticket Id
                    name: 'Id',
                    label: _("<span class='icon-ticket'></span> Ticket Id"), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Ticket Id'), // Placeholder text
                },
            ],
        };

        // Center right section with IsTest dropdown
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting test status
                    name: 'IsTest',
                    localId: 'isTest:combo', // Local ID for the component
                    label: _('Es Test'), // Label for the dropdown
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the left, center left, and center right components
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive behavior for the section
                    margin: 10,
                    cols: [left, center_left, center_right],
                },
            ],
        };

        // Button section with Clear and Consult buttons
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        this.getRoot().clear(); // Clear the form values
                    },
                },
                {
                    view: 'button', // Button to consult/filter the report
                    value: _('Consultar'), // Button label
                    type: 'form', // Type indicating it's a form button
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('betsReport:filter', [filterdata]); // Trigger filter event with values
                    },
                },
            ],
        };

        // Returning the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Rows containing upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
